import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import {store} from "./store";


if (document.getElementById("lections")) {
    let lectionFilters = {
        filters: {},
        enableNmo: enableNmo,
        clearFilters() {
            this.filters = {
                spec_id: $(".specializations-select").select2("data")[0].id
                    ? $(".specializations-select").select2("data")[0].id
                    : $(".specializations-select").val(),
                direction_id: null,
                section_id: null,
                cycle_id: null,
                is_nmo: 0,
                test_not_passed: 0,
                pagination: null,
                schedule: function get() {
                    return document.location.pathname == "/lections" ? 1 : 0;
                }
            };
        },
        init() {
            let self = this;
            this.clearFilters();
            self.filters.is_nmo = enableNmo;
            $(".nmo").prop("checked", enableNmo);
            $(document).on("getFilters", function (e) {
                self.setFilters(e.detail);
            });
            $(".filters-form .select-filter").on("select2:select", function () {
                self.getFilters();
                $(".filters-form").addClass("loading");
            });
            $(".specializations-select").on("change", function () {
                self.clearFilters();
                $(".nmo")
                    .prop("checked", null)
                    .trigger("refresh");
                self.filters.spec_id = $(this).val();
                $(".no_done_test")
                    .prop("checked", null)
                    .trigger("refresh");
                self.filters.test_not_passed = 0;
            });
            $(".sections-select").on("change", function () {
                self.filters.section_id = $(this).val();
            });
            $(".nmo").on("change", function () {
                self.filters.is_nmo = self.filters.is_nmo === 0 ? 1 : 0;
                self.getFilters();
                $(".filters-form").addClass("loading");
            });
            $(".no_done_test").on("change", function () {
                self.filters.test_not_passed =
                    self.filters.test_not_passed === 0 ? 1 : 0;
                self.getFilters();
                $(".filters-form").addClass("loading");
            });
            $(".programs-select").on("change", function () {
                self.filters.direction_id = $(this).val();
            });
            $(".cycles-select").on("change", function () {
                self.filters.cycle_id = $(this).val();
            });
            self.getFilters();
        },
        setFilters(filters) {
            var that = this;

            if (!this.filters.section_id) {
                $(".sections-select")
                    .find("option[data-insert='true']")
                    .remove();

                $.each(filters.sections, function (i, v) {
                    $(".sections-select").append(
                        $("<option>", {
                            selected: that.filters.section_id == v.id ? true : false,
                            value: v.id,
                            text: v.name,
                            "data-insert": true
                        })
                    );
                });
            }

            if (!this.filters.direction_id) {
                $(".programs-select")
                    .find("option[data-insert='true']")
                    .remove();

                $.each(filters.directions, function (i, v) {
                    $(".programs-select").append(
                        $("<option>", {
                            selected: that.filters.direction_id == v.id ? true : false,
                            value: v.id,
                            text: v.short_name,
                            "data-insert": true
                        })
                    );
                });
            }

            if (!this.filters.cycle_id) {
                $(".cycles-select")
                    .find("option[data-insert='true']")
                    .remove();
                $.each(filters.cycles, function (i, v) {
                    $(".cycles-select").append(
                        $("<option>", {
                            selected: that.filters.cycle_id == v.id ? true : false,
                            value: v.id,
                            text: v.name,
                            "data-insert": true
                        })
                    );
                });
            }

            $(".filters-form").removeClass("loading");
        },
        getFilters() {
            var that = this;

            lections.fetchLections();

            try {
                $.ajax({
                    url: "/lections/default/get-filters",
                    dataType: "json",
                    data: {
                        params: that.filters
                    },
                    success: function (data) {
                        document.dispatchEvent(
                            new CustomEvent("getFilters", {
                                bubbles: true,
                                detail: data
                            })
                        );
                    },
                    fail: function () {
                        throw new Error("Ошибка получении данных");
                    }
                });
            } catch (e) {
                //Отправить данные об ошибке в систему логов

                console.error(e);
            }
        }
    };
    let month;
    let lections = new Vue({
        el: "#lections",
        store,
        data: {
            lections: {},
            page: 1,
            pageCount: 0,
            filters: {
                pagination: null
            },
            dayNow: Math.round(new Date().getTime() / 1000),
            delayTime: 14400,
            load: false,
            get month() {
                return month;
            },
            os: store.state.os,
            filter: {}
        },
        filters: {
            plural(number, titles) {
                let cases = [2, 0, 1, 1, 1, 2];

                return titles[
                    number % 100 > 4 && number % 100 < 20
                        ? 2
                        : cases[number % 10 < 5 ? number % 10 : 5]
                    ];
            }
        },
        mounted() {},
        methods: {
            monthTime(date) {
                let monthsAll = [
                    "Январь",
                    "Февраль",
                    "Март",
                    "Апрель",
                    "Май",
                    "Июнь",
                    "Июль",
                    "Август",
                    "Сентябрь",
                    "Октябрь",
                    "Ноябрь",
                    "Декабрь"
                ];
                let monthCurrent = new Date(date ? date * 1000 : new Date()).getMonth();

                if (month !== monthsAll[monthCurrent]) {
                    month = monthsAll[monthCurrent];

                    return month;
                } else {
                    return false;
                }
            },
            classRating(rating) {
                return {
                    best: rating > 4,
                    good: rating > 3 && rating <= 4,
                    normal: rating > 2 && rating <= 3,
                    poorly: rating > 1 && rating <= 2,
                    bad: rating <= 1,
                    none: rating <= 0
                };
            },
            fetchLections(append) {
                let self = this;
                this.load = true;
                try {
                    let data = lectionFilters.filters;
                    $.extend(data, {page: this.page});
                    $.ajax({
                        url: "/api/v1/lection",
                        dataType: "json",
                        data: lectionFilters.filters,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {
                                    self.lections.items.push(item);
                                });
                            } else {
                                self.lections = data;
                                self.pageCount = data._meta.pageCount;
                                self.page = 1;
                            }
                            self.load = false;
                        },
                        fail: function () {
                            throw new Error("Ошибка получении данных");
                        }
                    });
                } catch (e) {
                    console.error(e);
                }
            },
            nextPage() {
                this.page = this.page + 1;
                this.fetchLections(true);
            },
            setPagination(pagination) {
                lections.filters.pagination = pagination;
                lectionFilters.filters.pagination = pagination;

                lectionFilters.getFilters();

                this.fetchLections();
            },
            getLectionMonth(date) {
                let month;
                console.log(month);
                let monthsAll = [
                    "Январь",
                    "Февраль",
                    "Март",
                    "Апрель",
                    "Май",
                    "Июнь",
                    "Июль",
                    "Август",
                    "Сентябрь",
                    "Октябрь",
                    "Ноябрь",
                    "Декабрь"
                ];
                let monthCurrent = new Date(date ? date * 1000 : new Date()).getMonth();
                if (month !== monthsAll[monthCurrent]) {
                    this.month = monthsAll[monthCurrent];

                    return monthsAll[monthCurrent];
                } else {
                    return false;
                }
            },
            getDelayTime(time) {
                let currentDate = Date.now();
                let startDay = new Date(time * 1000 - currentDate);

                var returnStr = "";

                if (startDay.getUTCHours() > 0) {
                    return (returnStr += startDay.getUTCHours() + " ч. ");
                }

                if (startDay.getMinutes() > 0) {
                    return (returnStr += startDay.getMinutes() + " мин. ");
                }
                return returnStr + "1 мин.";
            }
        },
    });
    jQuery(document).ready(function () {
        lectionFilters.init();
    });
}
